import { render, staticRenderFns } from "./cancer.vue?vue&type=template&id=73f1c18b&scoped=true"
import script from "./cancer.vue?vue&type=script&lang=js"
export * from "./cancer.vue?vue&type=script&lang=js"
import style0 from "./cancer.vue?vue&type=style&index=0&id=73f1c18b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f1c18b",
  null
  
)

export default component.exports